<template>
    <div id="app">
        <transition :name="transitionName">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
    import cookie from './utils/cookie.js'
    export default { 
        data() {
            return {
                transitionName: ''
            }
        },
        methods: {},
        created() {
            // 初始化token
            cookie.set('ctl-token','')
            localStorage.setItem('ctl-token', '')


            // 注入token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')
            if (ctlToken) {
                cookie.set('ctl-token',JSON.parse(ctlToken).token)
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }
        } 
    }
</script>
<style lang="scss">
    //css
    body, html, #app {
        margin: 0;
        padding: 0;
        -webkit-overflow-scrolling: touch;
    }

    * {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;
        margin: 0;
    }

    .anchorBL {
        display: none;
    }

    .wrap-content {
        font-family: Arial, "Microsoft YaHei", 黑体, 宋体, sans-serif;
    }

    .content {
        p {
            img {
                max-width: 100% !important;
                text-align: center;
            }

        }
    }

    .slide-right-enter-active,
    .slide-right-leave-active,
    .slide-left-enter-active,
    .slide-left-leave-active {
        will-change: transform;
        transition: all .5s;
        position: absolute;
    }

    .slide-right-enter {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }

    .slide-right-leave-active {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .slide-left-enter {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    .slide-left-leave-active {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }

    .van-button__text, .van-button__content {
        display: block;
        width: 100%;
        text-align: center;
    }
</style>
